import React, { useContext, useEffect } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CalenderEventComponent from '../../sharedComponents/calenderEvents/CalenderEventComponent';
import { useLocation } from 'react-router-dom';
import AppDataContext from '../../common/AppContext';
import useTelemetry from '../../utils/useTelemetry';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardContainer: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.spacing(2),
        marginTop: theme.spacing(0.5),
        marginBottom: theme.spacing(1),
        display: 'flex',
        alignItems: 'flex-start',
        padding: theme.spacing(5),
        width: '100%',
        boxSizing: 'border-box',
    }
}));

const EventCalendarScreen = (props) => {
    const classes = useStyles();
    const location = useLocation();
    const { trackCustomEvents } = useTelemetry();
    const {
        setMobileView
    } = useContext(AppDataContext);
    // Extract query parameters (React Router v5 way)
    const searchParams = new URLSearchParams(location.search);
    const queryParam = searchParams.get('params');
    const view = searchParams.get('view');

    useEffect(() => {
        if (view && view === 'm') {
            setMobileView(true)

        }

        // Track the event with telemetry
        trackCustomEvents("ClickEvent", { event: "Event Calender Viewed" });
        return () => {
            // Anything in here is fired on component unmount.
            setMobileView(false)
        }
    }, [])

    return (
        <Box className={classes.root}>
            <Box className={classes.cardContainer}>
                <CalenderEventComponent payload={queryParam} />
            </Box>
        </Box>
    );
};

export default EventCalendarScreen;
